exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{box-sizing:border-box}body{margin:0}#stats{position:absolute;left:0;top:0;display:block;z-index:2}.dg{z-index:2!important}*,:after,:before{box-sizing:inherit}canvas{position:absolute;top:0;left:0;right:0;bottom:0}", ""]);

// exports
